/**
 * A determinate ring for the round's overall progress.
 *
 * Deliberately not animated: the value is a real fraction of real work, and an
 * eased count-up would imply precision (and momentum) the underlying data
 * doesn't have. See DESIGN.md — never animate a number in a way that
 * misrepresents it.
 */
export function TodoProgressRing({
  fraction,
  size = 36,
  strokeWidth = 3,
}: {
  fraction: number;
  size?: number;
  strokeWidth?: number;
}) {
  const radius = 15;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(1, fraction));

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      aria-hidden
      className="flex-none"
    >
      <circle
        cx="18"
        cy="18"
        r={radius}
        fill="none"
        strokeWidth={strokeWidth}
        className="stroke-border-subtle"
      />
      <circle
        cx="18"
        cy="18"
        r={radius}
        fill="none"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={circumference * (1 - clamped)}
        transform="rotate(-90 18 18)"
        className="stroke-primary"
      />
    </svg>
  );
}
